/**
 * @packageDocumentation
 * @module f1/is
 */

import to_type from '../to/to_type';

export interface IsPromise {
  /**
   * Is the value a promise
   *
   * @public
   * @function f1.is.promise
   * @example
   *
   * ```ts
   * f1.is.promise(new Promise((resolve) => { resolve(); })) => true
   * f1.is.promise(function() {}) => false
   * ```
   */
  (u: unknown): u is Promise<unknown>;
}

/**
 * @see IsPromise
 */
export default (u: unknown): u is Promise<unknown> => {
  return to_type(u) === 'Promise';
};
